// 本地存储问卷弹窗是否已经弹窗
export const QUESTIONNAIRE_POP_IS_EXIST = 'QUESTIONNAIRE_POP_IS_EXIST';

// 医生个人信息
export const DOCTOR_INFO = 'doctorInfo';

// 患者详情搜索(类型分类和时间分类)的历史记录
export const PATIENT_DETAILS_SEARCH_HISTORY = 'patientDetailsSearchHistory';

// 患教宣传详情信息
export const PATIENT_EDUCATION = 'patientEducation';

// 自动导入分组 搜索
export const GROUP_AUTO_IMPORT = 'groupAutoImport';

// 患者列表表头配置
export const PATIENT_LIST_COLUMN_CONFIG = 'PATIENT_LIST_COLUMN_CONFIG';
